export default "__VITE_ASSET__WwDJ6eaZ__"